// Sizes a scrolling table box so it ends just above the bottom of the
// screen, leaving `reserve` px for what sits under it (the page numbers).
// Measured, not guessed: re-runs when the window resizes or anything above
// the box changes height (filter chips wrapping, a banner…). Print and the
// PDF capture ignore it (their CSS sets max-height: none !important).

import { useEffect, type RefObject } from 'react';

export function useFitHeight(ref: RefObject<HTMLElement | null>, reserve = 56, min = 280, deps: unknown[] = []) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const scroller = el.closest('.app-main') as HTMLElement | null;
    const fit = () => {
      // Distance from the top of the page content, as if not scrolled.
      const top = el.getBoundingClientRect().top + (scroller?.scrollTop ?? 0);
      el.style.maxHeight = `${Math.max(min, Math.floor(window.innerHeight - top - reserve))}px`;
    };
    fit();
    window.addEventListener('resize', fit);
    const ro = new ResizeObserver(fit);
    const page = el.closest('.page-content');
    if (page) for (const child of Array.from(page.children)) if (child !== el && !child.contains(el)) ro.observe(child);
    return () => { window.removeEventListener('resize', fit); ro.disconnect(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, reserve, min, ...deps]);
}
